import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetImagesVehiclesRequest extends ValueObject {
  #vehicleId
  #modelId
  #angle

  constructor({vehicleId, modelId, angle}) {
    super()
    this.#vehicleId = vehicleId
    this.#modelId = modelId
    this.#angle = angle
  }

  static validate({vehicleId, modelId}) {
    if (!vehicleId && !modelId) {
      throw InvalidParamsSharedError.create('[GetImagesVehiclesRequest.validate] vehicleId or modelId is required')
    }
  }

  static create({vehicleId, modelId, angle} = {}) {
    GetImagesVehiclesRequest.validate({vehicleId, modelId})
    return new GetImagesVehiclesRequest({vehicleId, modelId, angle})
  }

  toJSON() {
    return {
      vehicleId: this.#vehicleId,
      modelId: this.#modelId,
      angle: this.#angle
    }
  }
}
